<template lang="pug">
  b-container.content-wrap(fluid :class="{ 'is-mobile': isMobile }")
    b-container.d-flex.justify-content-between(fluid)
      .title
        span.page-title {{$t('top10')}} {{$t('statistics')}}
    b-row.search-form.justify-content-start.align-items-center
      b-col.mmb-10(cols="12" lg="4").d-flex.justify-content-start
        b-form-datepicker(
          v-model="range.start"
          :bootstrap-styling="true"
          :language="range.lang"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="getData"
        )
        b-form-datepicker.ml-2(
          v-model="range.end"
          :bootstrap-styling="true"
          :language="range.lang"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          format="yyyy-MM-dd"
          size="sm"
          @input="getData"
        )
        b-button.ml-2(size="sm" @click="getData" variant="secondary" ) {{$t('search')}}

    b-card.table-card.mb-4
      template(slot="header") {{$t('by_user', {v: $t('remote.remote.title')})}}
      b-table(
        :busy.sync="remoteUser.busy"
        :fields="remoteUser.fields"
        :items="remoteUser.items"
        :empty-text="$t('no-content')"
        show-empty
        responsive
      )
        template(#table-colgroup)
          col(style="width:15%" span="4")
          col

        template(v-slot:cell(reg_mail)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.reg_pk}}") {{row.item.reg_mail}}
        
        template(v-slot:cell(reg_name)="row")
          b-btn(variant="link" :to="{name: 'edit-manager', params: {userPk: row.item.reg_pk}}") {{row.item.reg_name}}
        
        template(v-slot:cell(part_name)="row")
          b-btn(variant="link", :to="{name: 'user-edit-department', params: {id: row.item.part_pk}}") {{row.item.part_name}}

        template(v-slot:cell(graph)="row") {{Math.round(row.item.usage)}}%
    
    b-card.table-card.mb-4
      template(slot="header") {{$t('statistics_page.manager_remote_control_by_os')}}
      b-table(
        :busy.sync="remoteDevice.busy"
        :fields="remoteDevice.fields"
        :items="remoteDevice.items"
        :empty-text="$t('no-content')"
        show-empty
        responsive
      )
        template(#table-colgroup)
          col(style="width:15%" span="2")
          col
        template(v-slot:cell(viewer_os)="row") {{ row.item.viewer_os | osPrint }}
        template(v-slot:cell(graph)="row") {{Math.round(row.item.usage)}}%
</template>

<script>
import axios from "axios"
import moment from "moment"
import _ from "lodash"
import store from "@/api/store"
import { getCurrentLanguage } from "@/i18n"
import * as datePickerLocale from "vuejs-datepicker/dist/locale"
import Datepicker from "vuejs-datepicker"
import { AnalysticAPI } from "../../api"
import { user } from "../../api/access"
export default {
  name: "rate-summary-component",
  components: { Datepicker },
  filters: {
    osPrint(value) {
      return {
        0: "UNKNOWN",
        1: "Windows",
        2: "Linux",
        3: "OS_X",
        4: "Android",
        5: "iOS",
      }[value]
    },
  },
  computed: {
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  mounted() {
    const stored = store.get(`analystic-dash-${user().pk}`)
    if (stored) {
      this.remoteUser.items = stored.remoteUser.filter(item => item.usage !== -1)
      this.remoteDevice.items = stored.remoteDevice.filter(item => item.usage !== -1)
      this.alertType.items = stored.alertType
      this.alertDevice.items = stored.alertDevice
    }
    this.getData()
  },
  methods: {
    startDateChanged(date) {
      this.range.start = date
      this.range.disabledDates.to = date
    },
    endDateChanged(date) {
      this.range.end = date
    },
    getData() {
      this.remoteUser.busy = true
      this.remoteDevice.busy = true
      this.alertType.busy = true
      this.alertDevice.busy = true

      const rootParams = {
        limit: 10,
        offset: 0,
        order: "desc",
        search_mode: "pagination",
        start_date: moment(this.range.start).format("YYYY-MM-DD"),
        end_date: moment(this.range.end).format("YYYY-MM-DD"),
      }

      const remoteByUserParams = _.assign({}, rootParams, { by: "mgrid", type: "user" })
      const remoteByDeviceParams = _.assign({}, rootParams, { by: "mgrid", type: "device" })
      const alertByUserParams = _.assign({}, rootParams, { by: "create_time", type: "user" })
      const alertByDeviceParams = _.assign({}, rootParams, { by: "create_time", type: "device" })
      const remoteByDeviceParams2 = _.assign({}, rootParams, { by: "mgrid", type: "agent" })
      const xhr = axios.all([
        AnalysticAPI.dash.get("remote", { params: remoteByUserParams }),
        AnalysticAPI.dash.get("remote", { params: remoteByDeviceParams }),
        AnalysticAPI.dash.get("alert", { params: alertByUserParams }),
        AnalysticAPI.dash.get("remote", { params: remoteByDeviceParams2 }),
      ])

      this.remoteUser.total = 0
      this.remoteDevice.total = 0
      this.alertType.total = 0
      this.alertDevice.total = 0

      xhr.then(
        axios.spread((remoteUser, remoteDevice, alertType, alertDevice) => {
          this.remoteUser.items = remoteUser.data.objects
            .filter(item => item.usage !== -1)
            .sort((a, b) => b.count - a.count)
            .map(v => {
              if (v.count === -1) {
                v.reg_mail = "-"
                v.count = null
              } else this.remoteUser.total += v.count
              return v
            })

          this.remoteDevice.items = remoteDevice.data.objects
            .filter(item => item.usage !== -1)
            .sort((a, b) => b.count - a.count)
            .map(v => {
              if (v.count === -1) {
                v.alias = "-"
                v.count = null
              } else this.remoteDevice.total += v.count
              return v
            })

          this.alertType.items = alertType.data.objects
            .sort((a, b) => b.count - a.count)
            .map(v => {
              if (v.count === -1) {
                v.category = "-"
                v.count = null
              } else this.alertType.total += v.count
              return v
            })

          this.agentDevice.items = remoteDevice.data.objects
            .filter(item => item.usage !== -1)
            .sort((a, b) => b.count - a.count)
            .map(v => {
              if (v.count === -1) {
                v.alias = "-"
                v.count = null
              } else this.remoteDevice.total += v.count
              return v
            })

          this.remoteUser.busy = false
          this.remoteDevice.busy = false
          this.alertType.busy = false
          this.alertDevice.busy = false
          this.agentDevice.busy = false

          store.set(`analystic-dash-${user().pk}`, {
            remoteUser: this.remoteUser.items,
            remoteDevice: this.remoteDevice.items,
            alertType: this.alertType.items,
            alertDevice: this.alertDevice.items,
          })
        }),
      )
    },
  },
  data() {
    let disabledDateInit = new Date()
    disabledDateInit.setDate(-1)
    return {
      range: {
        start: moment()
          .add(-14, "days")
          .toDate(),
        end: moment().toDate(),
        disabledDates: { to: disabledDateInit },
        lang: datePickerLocale[getCurrentLanguage()],
      },
      remoteUser: {
        busy: true,
        total: 0,
        fields: [
          { key: "reg_mail", label: this.$t('ID'), thStyle: { minWidth: "120px" } },
          { key: "reg_name", label: this.$t('account-manage'), thStyle: { minWidth: "120px" } },
          { key: "part_name", label: this.$t('department'), thStyle: { minWidth: "120px" } },
          { key: "count", label: this.$t("use_count"), thStyle: { minWidth: "80px" } },
          { key: "graph", label: this.$t("use_rate"), thStyle: { minWidth: "80px" } },
        ],
        items: [],
      },
      remoteDevice: {
        busy: true,
        total: 0,
        fields: [
          { key: "viewer_os", label: `${this.$t('manager_str')} OS`, thStyle: { minWidth: "120px" } },
          { key: "count", label: this.$t('statistics_page.connection_count'), thStyle: { minWidth: "80px" } },
          { key: "graph", label: this.$t('rate'), thStyle: { minWidth: "80px" } },
        ],
        items: [],
      },
      agentDevice: {
        busy: true,
        total: 0,
        fields: [
          { key: "viewer_os", label: `${this.$t('device')} OS`, thStyle: { minWidth: "120px" } },
          { key: "count", label: this.$t('statistics_page.connection_count'), thStyle: { minWidth: "80px" } },
          { key: "graph", label: this.$t('rate'), thStyle: { minWidth: "80px" } },
        ],
        items: [],
      },
      alertType: {
        busy: true,
        total: 0,
        fields: [
          { key: "category", label: this.$t("alert") },
          { key: "count", label: this.$t("use_count") },
          { key: "graph", label: this.$t("use_rate") },
        ],
        items: [
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
          { category: "", usage: -1 },
        ],
      },
      alertDevice: {
        busy: true,
        total: 0,
        fields: [
          { key: "device", label: this.$t('remote_device') },
          { key: "graph", label: `${this.$t('remote_device')} IP` },
          { key: "graph", label: this.$t('account-manage') },
          { key: "count", label: this.$t('statistics_page.connection_count') },
          { key: "count", label: this.$t('rate') },
        ],
        items: [
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
          { device: "", usage: -1 },
        ],
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.search-form {
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 20px !important;
}
</style>
